import { isObjectLike } from 'gleam-shared/helpers/nodash'

export default function safeParse(json) {
  try {
    if (isObjectLike(json)) {
      return json
    } else {
      return JSON.parse(json)
    }
  } catch (_err) {
    return undefined
  }
}
